<template>
  <div class="mt-4">
    <div id="roi_sales_service_line_chart"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ROISalesServiceLine",
  data: () => {
    return {
      graphedServiceRevenue: [],
      graphedSalesRevenue: [],
      graphedLabels: []
    };
  },
  methods: {
    addtoplot(item, index) {
      this.graphedLabels.push(item.Label);
      this.graphedSalesRevenue.push([index, item.SaleRevenue]);
      this.graphedServiceRevenue.push([index, item.ServiceRevenue]);
    },
    async LoadGraphData() {
      if (this.$store.state.campaign.campaign_roi.ActivityCountGraphSeries) {
        this.graphedLabels.length = 0;
        this.graphedSalesRevenue.length = 0;
        this.graphedServiceRevenue.length = 0;
        await this.$store.state.campaign.campaign_roi.ActivityCountGraphSeries.forEach(
          function(element, index) {
            this.addtoplot(element, index);
          },
          this
        );
      }
    },
    async MyRenderGraph() {
      var options_roi_sales_service_line = {
        series: [
          {
            name: "Service Revenue",
            data: this.graphedServiceRevenue
          },
          {
            name: "Sales Revenue",
            data: this.graphedSalesRevenue
          }
        ],
        stroke: {
          width: 2,
          curve: "smooth"
        },
        chart: {
          type: "line",
          height: 400
        },
        dataLabels: {
          enabled: false
          // formatter: function(val) {

          //   return val; // Simply return the raw value
          // }
        },
        labels: this.graphedLabels,

        legend: {
          position: "bottom",
          fontSize: "16px",
          fontWeight: 500
        },
        colors: ["#e23e25DE", "#36454fDE", "#F0DC36DE", "#ADADADDE"]
      };

      var roi_sales_service_line = new ApexCharts(
        document.querySelector("#roi_sales_service_line_chart"),
        options_roi_sales_service_line
      );

      roi_sales_service_line.render();
    }
  },
  props: {},
  components: {},
  computed: {
    ...mapState(["campaign"])
  },
  created() {
    this.LoadGraphData();
    this.MyRenderGraph();
  },
  mounted() {
    this.MyRenderGraph();
  },
  watch: {
    "$store.state.campaign.campaign_roi.ActivityCountGraphSeries": function(
      newVal,
      oldVal
    ) {
      this.LoadGraphData();
      this.MyRenderGraph();
    }
  }
};
</script>

<style lang="scss" scoped></style>
